import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      border: '1px dashed #707070',
      borderRadius: '4px',
      minHeight: '160px',
      width:'150px',
      // margin: '10px 20px',
      backgroundColor: '#F5F5F5',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px 17px',
      margin: '10px',

      '& svg': {
        width: '38px',
        height: '70px'
      }
    },
    text: {
      '& svg': {
        width: '18px',
        height: '17px'
      },
      '& p': {
        fontSize: '10px'
      }
    },
    textlayout: {
      display: 'flex',
      flexDirection: 'column',
      // border: '2px solid red',
      height: '30px',
      width: '90%',
      // margin: '0px 0px 20px 0px',
      // justifyContent: 'space-around',
    },
    uploadfiledescription: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#545456',
      //   border: '2px solid red',
      margin: '8px 0px 0px 0px',
      textAlign: 'center',
    },
  }),
  { index: 1 },
)

export { useStyles }
